import dayjs from "dayjs";
import { SearchFormInputs } from "src/Modules/Flights/constants";

const prepareSearchObject = (searchObject: SearchFormInputs) => {
  return {
    ...searchObject,
    preferredDepartureTime: dayjs(searchObject.preferredDepartureTime),
    preferredReturnTime: dayjs(searchObject.preferredReturnTime),
  };
};

export { prepareSearchObject };
